








































































































import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { PronosticoHidricoApi } from '@/domain/entities/Api'
import { Chart } from 'highcharts-vue'
import { isMobile } from './helpers/utils'

@Component({
  components: {
    'highcharts': Chart,
    Swiper,
    SwiperSlide
  }
})
export default class InfoView extends Vue {
  @Prop({ type: Object }) infoviewData!: PronosticoHidricoApi
  @Prop() title!: string
  @Prop() link!: string
  @Prop() subtitle!: string
  @Prop() subtitle2!: string
  @Prop() emptyResponse!: string
  @Prop() date!: string
  @Prop() data!: any
  @Prop() chartOptions!: any

  tabModel = 0

  isMobile = isMobile()

  chartOptionsBase: Highcharts.Options = {
    time: {
      useUTC: false
    },
    title: { style: { display: 'none' } },
    chart: {
      spacingLeft: 3,
      spacingRight: 3,
      zoomType: 'xy'
    },
    series: [],
    yAxis: {
      title: undefined,
      labels: {
        style: {
          fontSize: '8px'
        }
      }
    },
    xAxis: {
      title: undefined,
      type: 'datetime',
      labels: {
        style: {
          fontSize: '8px'
        }
      }
    },
    legend: {
      enabled: false
    },
    credits: { enabled: false }
  }

  swiperOptions = {
    initialSlide: 0,
    pagination: {
      el: '.swiper-pagination',
      clickable: true
    },
    navigation: {
      nextEl: '#swiper-btn-next',
      prevEl: '#swiper-btn-prev'
    }
  }

  get computedChartOptions (): Highcharts.Options[] {
    return this.chartOptions && this.chartOptions.map ? this.chartOptions.map((chartOption: any) => ({
      ...this.chartOptionsBase,
      ...chartOption
    })) : []
  }

  @Watch('computedChartOptions')
  onChartOptionsChanged (map: google.maps.Map, oldMap: google.maps.Map) {
    this.$nextTick(() => {
      if (this.$refs.mySwiper) {
        // @ts-ignore
        this.$refs.mySwiper.$swiper.slideTo(0, 0, false)
      }
    })
  }

  get hasSeries (): boolean {
    const countSeries = this.computedChartOptions.reduce((accumulator: number, chartOption) => {
      const series = (chartOption.series && chartOption.series.length) || 0
      return accumulator + series
    }, 0)
    return countSeries > 0
  }
}
